import SearchPickerController from "./search_picker_controller"

export default class extends SearchPickerController {
  get searchUrl() {
    return this.searchUrlValue || "/brands/search.json?search[term]="
  }
}
